import { z } from 'zod';

export type DealerProspect = z.TypeOf<typeof DealerProspectSchema>;

export enum LeadType {
  Event = 'event',
  Travel = 'travel',
  Referral = 'referral',
  Other = 'other',
}

export enum Division {
  CCL = 'ccl',
  TSF = 'tsf',
}

export const DealerProspectSchema = z.object({
  id: z.string(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  isArchived: z.boolean().optional(),

  date: z.string(),
  // division: z.nativeEnum(Division).optional(),
  teamMemberName: z.string(),
  createdBySub: z.string().optional(),
  leadType: z.nativeEnum(LeadType),
  leadTypeName: z.string(),
  dealershipName: z.string(),
  contactFirstName: z.string(),
  contactLastName: z.string(),
  phone: z.string(),
  email: z.string(),
  physicalAddress: z.object({
    addressLine1: z.string(),
    addressLine2: z.string().nullish().optional(),
    city: z.string(),
    state: z.string(),
    zipCode: z.string(),
  }),
  notes: z.string().optional(),
});

export type CreateDealerProspectRequest = z.TypeOf<typeof CreateDealerProspectRequestSchema>;

export const CreateDealerProspectRequestSchema = z.object({
  date: z.string(),
  // division: z.nativeEnum(Division).optional(),
  teamMemberName: z.string(),
  leadType: z.nativeEnum(LeadType),
  leadTypeName: z.string().optional(),
  dealershipName: z.string(),
  contactFirstName: z.string(),
  contactLastName: z.string(),
  phone: z.string(),
  email: z.string(),
  physicalAddress: z.object({
    addressLine1: z.string(),
    addressLine2: z.string().nullish().optional(),
    city: z.string(),
    state: z.string(),
    zipCode: z.string(),
  }),
  notes: z.string().optional(),
});
